import history from '../utils/history.js'
import messages from '@configs/messages'
import auth from '../pages/Auth/lib'

/**
 * 
 * @param {String} url API endpoint
 * @param {{method, query, headers, body, secure}} options API endpoint
 * @param {({status, loaded, done, body}) => {}} callback Streaming function
 */
export function fetchStream(url, options, callback) {
    return new Promise(async (resolve, reject) => {
        let { method, query, headers, body, secure } = options
        headers = headers || {}
        let queries = []
        if (query) Object.keys(query).forEach(k => {
            queries.push(`${k}=${encodeURIComponent(query[k])}`)
        })
        if (secure) {
            if (!auth.isAuthenticated) {
                history.push(`/login?context=qrcode-app&redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`, { redirect: encodeURIComponent(window.location.pathname + window.location.search) })
                return window.location.reload()
            }
            headers['Authorization'] = localStorage.getItem('sid') || `Bearer ${auth.getSession('qc_sid')}`
        }

        const response = await fetch(`${url}${queries.length > 0 ? `${(url + '').indexOf('?') !== -1 ? '&' : '?'}${queries.join('&')}` : ''}`, {
            // keepalive: true,
            method: method || 'GET',
            headers,
            body
        })
        // if (!!secure && [401, 403].includes(response.status)) {
        //     history.push('/login', {redirect: encodeURIComponent(window.location.pathname + window.location.search)})
        //     return window.location.reload()
        // }
        callback({
            status: response.status,
            loaded: 0,
            done: false,
            body: {} //response.status >= 400 ? {message: messages.errors.http500} : null
        })
        // if(response.status >= 400) return;

        const reader = response.body.getReader()
        const contentLength = response.headers.get('Content-Length')
        let receivedLength = 0
        let chunks = []

        while (true) {
            const { done, value } = await reader.read()

            if (done) break

            chunks.push(value)
            receivedLength += value.length
            callback({
                status: response.status,
                loaded: receivedLength * 100 / contentLength,
                done: false,
                body: null
            })
        }

        let chunksAll = new Uint8Array(receivedLength)
        let position = 0
        for (const chunk of chunks) {
            chunksAll.set(chunk, position)
            position += chunk.length
        }

        const result = new TextDecoder('utf-8').decode(chunksAll)
        let triedParse = {}
        try {
            triedParse = JSON.parse(result)
        } catch (err) {
            triedParse = {
                message: response.status === 404 ? messages.errors.http404 : messages.errors.http500
            }
        }
        callback({
            status: response.status,
            loaded: 100,
            done: true,
            body: triedParse
        })
        resolve()
    })
}

export function fetch(url, options) {
    return new Promise((resolve, reject) => {
        let { method, query, headers, body, secure } = options
        headers = headers || {}
        let queries = []
        if (query) Object.keys(query).forEach(k => queries.push(`${k}=${encodeURIComponent(query[k])}`))
        if (secure) {
            if (!auth.isAuthenticated) {
                window.open(`/login?context=qrcode-app&redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`, { redirect: encodeURIComponent(window.location.pathname + window.location.search) }, '_self')
                // window.location.reload()
                return resolve()
            }
            headers['Authorization'] = localStorage.getItem('sid') || `Bearer ${auth.getSession('qc_sid')}`
            headers['x-role-context'] = 'admin'
        }
        window.fetch(`${url}${queries.length > 0 ? `${(url + '').indexOf('?') !== -1 ? '&' : '?'}${queries.join('&')}` : ''}`, {
            // keepalive: true,
            method: method || 'GET',
            headers,
            body
        })
            .then(
                res => res.json()
                    .then(data => resolve({
                        status: res.status,
                        body: data
                    }))
                    .catch(err => resolve({
                        status: res.status,
                        body: err.message || 'Something went wrong!'
                    }))
            )
            .catch(err => reject(err))
    })
}

export default fetch
